const activateAPI = {
  getSubscriptionsByEmailEndpoint: 'https://app.lrlos.com/webhook/activation-Look-up',
  generatePayNowLinkByCustomerIdEndpoint: 'https://app.lrlos.com/webhook/Pay-Now-Generate-Link',
  getSubscriptionsByCustomerIdEndpoint: 'https://app.lrlos.com/webhook/Get-Subscriptions',
};

const formatPlanName = (itemPriceId = '') => {
  const text = String(itemPriceId);
  if (!text) return 'Subscription';

  if (text.includes('USD')) {
    return text.split('USD')[0].replaceAll('-', ' ').trim().toLowerCase();
  }

  return text.replaceAll('-', ' ').trim().toLowerCase();
};

const formatPlanInterval = (itemPriceId = '') => {
  const text = String(itemPriceId);
  if (!text) return 'subscription';

  if (text.includes('USD')) {
    const part = text.split('USD')[1] || '';
    return part.replaceAll('-', ' ').trim().toLowerCase() || 'subscription';
  }

  return 'subscription';
};

const showActivateMain = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });

  const activateMainContainer = document.getElementById('activate-main-container');
  const activateMainHeaderText = document.getElementById('activate-main-header-text');
  const activateStepOne = document.getElementById('activate-main-step-one');
  const activateStepTwo = document.getElementById('activate-main-step-two');
  const activateStepThree = document.getElementById('activate-main-step-three');
  const activationForm = document.getElementById('activation-form');
  const activateStepOneFormButton = document.getElementById('activate-main-step-one-form-button');

  activationForm.style.display = 'none';
  activateMainContainer.style.display = 'flex';
  activateMainHeaderText.style.display = 'flex';
  activateStepOne.style.display = 'flex';
  activateStepTwo.style.display = 'none';
  activateStepThree.style.display = 'none';

  activateStepOneFormButton.innerHTML = 'CONTINUE';
  activateStepOneFormButton.disabled = false;
};

const showActivationForm = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });

  const activateMainContainer = document.getElementById('activate-main-container');
  const activationForm = document.getElementById('activation-form');

  activateMainContainer.style.display = 'none';
  activationForm.style.display = 'flex';
};

const showActivateMainStepThree = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });

  const activateStepTwo = document.getElementById('activate-main-step-two');
  const activateStepThree = document.getElementById('activate-main-step-three');
  const activationButton = document.getElementById('activate-main-step-three-buttons-activate-button');

  activateStepTwo.style.display = 'none';
  activateStepThree.style.display = 'flex';

  activationButton.onclick = () => {
    showActivationForm();
  };
};

const renderSubscriptions = (subscriptions = []) => {
  const activateStepTwoSubscriptionsList = document.getElementById('activate-main-step-two-subscriptions-list');

  activateStepTwoSubscriptionsList.innerHTML = '';

  subscriptions.forEach((subscription) => {
    const subscriptionId = safeText(subscription.subscription_id || '');
    const planName = safeText(formatPlanName(subscription.item_price_id));
    const planInterval = safeText(formatPlanInterval(subscription.item_price_id));
    const amount = Number(subscription.amount || 0) / 100;
    const modemICCID = safeText(subscription.cf_SIM_ID_ICCID || ',');
    const modemIMEI = safeText(subscription.cf_Device_IMEI || ',');

    activateStepTwoSubscriptionsList.innerHTML += `
      <li
        class="activate-main-step-two-subscriptions-list-item"
        id="activate-main-step-two-subscriptions-list-item-${subscriptionId}"
      >
        <button type="button">
          <div class="activate-main-step-two-subscriptions-list-item-main-content">
            <h4>
              ${planName}
              <span>Active</span>
            </h4>

            <h3>$${amount} / ${planInterval}</h3>

            <ul
              class="activate-main-step-two-subscriptions-list-item-main-content-details"
              id="activate-main-step-two-subscriptions-list-item-main-content-details-${subscriptionId}"
            >
              <li>
                <p>Modem ICCID</p>
                <p>${modemICCID}</p>
              </li>
              <li>
                <p>Modem IMEI</p>
                <p>${modemIMEI}</p>
              </li>
            </ul>

            <a class="btn btn-secondary activate-main-step-two-subscriptions-list-item-main-content-details-troubleshoot" href="javascript:void(0)" onclick="openChat()">
              TROUBLESHOOT
            </a>

            <a class="activate-main-step-two-subscriptions-list-item-main-content-details-info">
              <svg class="activate-main-step-two-subscriptions-list-item-main-content-details-info-tooltip-arrow" xmlns="http://www.w3.org/2000/svg" width="16" height="9" viewBox="0 0 16 9" fill="none">
                <path d="M14.0711 -6.26343e-05C14.962 -6.26343e-05 15.4081 1.07708 14.7782 1.70705L8.70711 7.77812C8.31658 8.16864 7.68342 8.16864 7.29289 7.77812L1.22183 1.70705C0.591867 1.07708 1.03803 -6.22128e-05 1.92894 -6.22128e-05L14.0711 -6.26343e-05Z" fill="white"/>
              </svg>
              <div class="activate-main-step-two-subscriptions-list-item-main-content-details-info-tooltip">
                <h4>Troubleshoot</h4>
                <p>Click <b>Troubleshoot</b> if you already have a device and an active subscription but need help setting it up. Click <b>Activate</b> if you're adding a new device or starting a new subscription.</p>
              </div>

              <span>More info</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <g clip-path="url(#clip0_26171_1171)">
                  <path d="M7 13.5C10.5899 13.5 13.5 10.5899 13.5 7C13.5 3.41015 10.5899 0.5 7 0.5C3.41015 0.5 0.5 3.41015 0.5 7C0.5 10.5899 3.41015 13.5 7 13.5Z" stroke="#666666" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M5.5 10H8.5" stroke="#666666" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7 10V6.5H6" stroke="#666666" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7 4.25C6.86193 4.25 6.75 4.13807 6.75 4C6.75 3.86193 6.86193 3.75 7 3.75" stroke="#666666" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7 4.25C7.13807 4.25 7.25 4.13807 7.25 4C7.25 3.86193 7.13807 3.75 7 3.75" stroke="#666666" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                  <clipPath id="clip0_26171_1171">
                    <rect width="14" height="14" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </button>
      </li>
    `;
  });
};

const showActivateMainStepTwo = (responseData) => {
  const activateMainHeaderText = document.getElementById('activate-main-header-text');
  const activateStepOne = document.getElementById('activate-main-step-one');
  const activateStepTwo = document.getElementById('activate-main-step-two');
  const activateStepThree = document.getElementById('activate-main-step-three');
  const activateStepTwoLoader = document.getElementById('activate-main-step-two-loader');
  const activateStepTwoSubscriptionsList = document.getElementById('activate-main-step-two-subscriptions-list');
  const activateStepTwoActivateButton = document.getElementById('activate-main-step-two-activate-button');

  activateMainHeaderText.style.display = 'none';
  activateStepOne.style.display = 'none';
  activateStepThree.style.display = 'none';
  activateStepTwo.style.display = 'flex';
  activateStepTwoLoader.style.display = 'flex';
  activateStepTwoSubscriptionsList.style.display = 'none';
  activateStepTwoSubscriptionsList.innerHTML = '';

  const subscriptions = Array.isArray(responseData?.[0]?.activeSubscriptions)
    ? responseData[0].activeSubscriptions
    : [];

  const pendingSubscriptions = subscriptions.filter((subscription) => {
    const imei = subscription?.cf_Device_IMEI;
    return !imei || String(imei).trim() === '' || String(imei).trim().toLowerCase() === 'pending';
  });

  if (subscriptions.length === 0) {
    showActivationForm();
    return;
  }

  if (pendingSubscriptions.length > 0) {
    showToast(
      'You already have a subscription but your IMEI has not been added. Please contact support.',
      'red',
      900000
    );
  }

  renderSubscriptions(subscriptions);

  activateStepTwoLoader.style.display = 'none';
  activateStepTwoSubscriptionsList.style.display = 'flex';

  activateStepTwoActivateButton.onclick = () => {
    if (pendingSubscriptions.length > 0) {
      showActivateMainStepThree();
    } else {
      showActivationForm();
    }
  };
};

window.addEventListener('DOMContentLoaded', () => {
  const activateStepOneForm = document.getElementById('activate-main-step-one-form');
  const activateStepOneFormButton = document.getElementById('activate-main-step-one-form-button');

  showActivateMain();

  activateStepOneForm.addEventListener('submit', async (e) => {
    e.preventDefault();

    const formData = new FormData(activateStepOneForm);
    const data = Object.fromEntries(formData.entries());
    const email = String(data.email || '').trim();

    if (!validateEmail(email)) {
      showToast('Error: Invalid email address');
      return;
    }

    activateStepOneFormButton.disabled = true;
    activateStepOneFormButton.innerHTML = `<div class="bar-loader-dark"></div>`;

    try {
      let response = await fetch(
        `${activateAPI.getSubscriptionsByEmailEndpoint}?email=${encodeURIComponent(email)}`,
        {
          method: 'GET',
          headers: {
            Authorization: 'whY-tSR2E12Y9QEIaZ9z'
          }
        }
      );

      if (!response.ok) {
        showActivationForm();
        return;
      }

      const json = await response.json();

      if (json?.error_code) {
        showActivationForm();
        return;
      }

      showActivateMainStepTwo(json);
    } catch (error) {
      console.error('Activation lookup failed:', error);
      showToast('Something went wrong. Please try again.');
      activateStepOneFormButton.disabled = false;
      activateStepOneFormButton.innerHTML = 'CONTINUE';
    }
  });
});
